export class SubscriptionPreferences {
    newTransactions = {
        title: "New Transactions",
        description: "Receive alerts when there are new transactions",
        checked: false
    }

    aboveLimit = {
        title: "Above Limit",
        description: "Receive alerts when the balance goes above the limit",
        checked: false
    }

    belowLimit = {
        title: "Below Limit",
        description: "Receive alerts when the balance goes below the limit",
        checked: false
    }
}

type EventName = "newTransactions" | "aboveLimit" | "belowLimit"